/**
 * @author      tae@zumper.com (Tae Yoon)
 * @copyright   Copyright (c) 2019, Zumper
 * @description Trovit conversion tracking service
 */

import { logger } from '../../../logger'
import { ON_BROWSER } from '../../env'

export default class Conversion {
  track(type = '', options = {}) {
    if (ON_BROWSER && typeof window !== 'undefined') {
      logger.debug('trovit track', type)
      try {
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'trovit_send',
            trovitEventType: type,
            trovitEventOptions: options,
          })
        } else if (window.ta) {
          window.ta('send', type, options)
        }
      } catch (e) {
        logger.error('trovit track failed:', type, e)
      }
    }
  }

  trackLead(options = {}) {
    this.track('lead', options)
  }
}
